<template>
    <div>&nbsp;</div>
</template>

<script lang="js">
export default {}
</script>